import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';

// Scenes
import Products from './scenes/Products';
import Diary from './scenes/Diary';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Fertilizer = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Fertilizer"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                {'Fertilizers - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <Switch>
            <Redirect
                exact
                from="/organization/fertilizer"
                to="/organization"
            />
            <Route
                exact
                path="/organization/fertilizer/diary"
                component={Diary}
            />
            <Route
                exact
                path="/organization/fertilizer/products"
                component={Products}
            />
            <Redirect from="/organization/fertilizer/*" to="/organization" />
        </Switch>
    </ErrorBoundary>
);

export default Fertilizer;
